import jquery from "jquery";

window.jQuery = window.$ = jquery;

import "jquery-validation";
import "es6-object-assign/auto";
